<template lang="pug">
	div
		.breadcrumbs
			.breadcrumb-back
				back-button
		vue-page-transition(name="fade")
			router-view
</template>

<script>
import BackButton from '@/components/BackButton'

export default {
	name      : 'AuthorWrapper',
	components: {
		BackButton
	}
}
</script>
